import { CLEAR_PRIVATE_PAYMENT, PLAN_EXPIRED } from "../../../../Helper/actionsTypes"

export const planReducer = (state = [], action) => {
    switch (action.type) {
        case PLAN_EXPIRED: {
            return { ...state, plan_expired: true, plan_expired_details: action.payload.results }
        }
        case CLEAR_PRIVATE_PAYMENT: {
            return {}
        }
        default: return state
    }
}